<template>
	<div :style="style">

        <!-- SQUARE -->
        <div v-if="square" :class="['square', {cursor: url}]" :style="{backgroundColor: color}" @click="goTo()">
            <div class="inner">
                <div class="icon" v-if="icon" >
                    <i :class="icon"></i>
                </div>
                <div class="desc">
                    <p v-if="text">{{text}}</p>
                </div>
            </div>
        </div>
        
        <!-- NORMAL -->
        <div v-else :class="['info-box', {cursor: url}]" @click="goTo()">
            <div class="icon" v-if="icon" :style="{backgroundColor: color}">
                <i :class="icon"></i>
            </div>
            <div class="desc">
                
                <div :style="{'flex-flow': flexFlow }">
                    <p v-if="text">{{text}}</p>
                    <b v-if="number">{{number}}</b>
                </div>

                <el-progress 
                    v-if="progress && progressPercent"
                    :text-inside="true" 
                    :stroke-width="20" 
                    :percentage="progressPercent">
                </el-progress>
            </div>
        </div>
       
	</div>
</template>

<script>
	export default {
		name: 'InfoBox',
		props: {
            icon: String,
            number: String,
            text: String,
            color: {
                type: String,
                default: '#4a596a'
            },
            square: {
                type: Boolean,
                default: false
            },
            url: String,
            progress: {
                type: Boolean,
                default: false
            },
            progressPercent: {
                type: Number
            },
            flexFlow: {
                type: String,
                default: 'column'
            },
            style: {
                type: String,
                default: ''
            }
		},
        methods: {
            goTo() {
                if (!this.url) {
                    this.$emit('click')
                    return
                }
                this.$router.push({ path: this.url.replace('/ficha','') })
                //window.open(this.url.replace('/ficha',''),'_blank')
            }
        }
	}
</script>

<style lang="scss">
.info-box {
    display: flex;
    align-items: center;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0,0,0,.15);
    border-radius: 6px;
    margin: 0px 0px 0px 0px;
    height: 75px;
    overflow: hidden;
    .icon {
        height: 100%;
        width: 75px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 25px;
        color:white;
    }
    .desc {
        flex-grow: 1;
        padding: 0 15px;
        p {
            margin: 0px 0px 5px 0px;
        }
        b {
            font-size: 1.5rem;
            font-weight: 400;
        }

        > div {
            display: flex;
            justify-content: space-between;
        }
    }
}

.square {
    width: 100%;
    height: auto;
    flex-flow: column;
    position: relative;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,.15);
    &:after {
        content: "";
        display: block;
        padding-bottom: 100%;
    }
    .inner {
        position: absolute;
        display: flex;
        justify-content: space-around;
        flex-flow: column;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        color:white;
        .icon {
            font-size: 30px;
            display: flex;
            height: 60%;
            align-items: flex-end;
            justify-content: center;
        }
        .desc {
            height: 40%;
            display: flex;
            justify-content: flex-end;
            padding: 0px 5px 8px 10px;
            align-items: flex-end;
            p {
                padding: 0px;
                margin: 0px;
                font-size: 0.75rem;
                line-height: 1.2;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }
    }
}

.cursor {
    cursor: pointer;
}
</style>
